<template>
  <div class="skeleton-card shimmer"></div>
</template>

<style scoped>
.skeleton-card {
  height: 160px;
  border-radius: 16px;
  background-color: #e0e0e0;
  position: relative;
}

.shimmer {
  background: linear-gradient(
    90deg,
    #e0e0e0 0%,
    #f0f0f0 50%,
    #e0e0e0 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

[data-theme="dark"] .skeleton-card {
  background-color: #2c2c2c;
}

[data-theme="dark"] .shimmer {
  background: linear-gradient(
    90deg,
    #2c2c2c 0%,
    #3a3a3a 50%,
    #2c2c2c 100%
  );
}
</style>